var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"standard_trade"},[_c('AntGridSkeleton',{attrs:{"height":"10rem","num":6,"rows":2,"gap":0.7,"loading":_vm.skeletonLoading}},[_c('div',{staticClass:"antd-row"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"antd-col"},[_c('Threshold',{attrs:{"data":item,"rows":6,"skip":_vm.skip}})],1)}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }